import React, { useState, useEffect } from "react";
import Navigation from "../../navigation/Navigation";
import { useDispatch, useSelector } from 'react-redux';
import { createProjects, updateProject, deleteProject, getProjects } from '../../actions/projects';
import { Grid, CircularProgress, Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * This page presents the user with a form to fill out to allow them to input their own project suggestion.
 * When the project is submitted it will automatically show up on the screen which lets them know it submitted properly and be sent to the 
 * student projects collection in the database.
 * If they already have a submitted project they are allowed to either edit or delete that project.
 * @returns the project creation form along with the project that was created by the user.
 */

const CreateEditProject = () => {
    const [postProject, setPostProject] = useState({
        title: '', supervisor: '', description: ''
    });

    const [id, setID] = useState(null)

    let projects = []
    const userProject = [];

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getProjects());
      }, [dispatch, postProject]);

    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateProject(id, postProject));
        } else {
            const assigning = Object.assign({}, postProject)
            assigning.userID = localStorage.getItem("id")
            if(userProject.length >= 1) {
                alert("Only allowed to create one project")
            } else {
                dispatch(createProjects(assigning));
                alert("Project successfully submitted")
            }
        }

        clearFields();
    }

    const handleProjectEdit = (project) => {
        const newProject = Object.assign({}, postProject)

        newProject.title = project.title;
        newProject.supervisor = project.supervisor;
        newProject.description = project.description;
        newProject.userID = localStorage.getItem("id");

        setID(project._id)
        setPostProject(newProject);
    }

    const clearFields = () => {
        setID(null);
        setPostProject({title: '', supervisor: '', description: ''});
    }

    const response = useSelector((state) => state.projects.data);
    if (response){
        projects = Array.from(response);
        projects.forEach(project => {
            if(project.userID === localStorage.getItem("id")) {
                userProject.push(project);
            }
        })
    }

    return(
        <div className="createProjectContainer">
            <Navigation/>
            <form id={id} onSubmit={submitHandler}>
               <h1>{id ? 'Edit Project' : 'Create Project'}</h1>
               <p>Please ensure that you have agreed before hand with your chosen supervisor that they will indeed supervise your project before submitting your project submission</p>
               <label>
                   Project Name: 
                   <input type="text" name="title" label="Name" value={postProject ? postProject.title : ''} onChange={(e) => setPostProject({...postProject, title: e.target.value})}></input>
               </label>
               <label>
                   Agreed Supervisor: 
                   <input type="text" name="supervisor" label="Supervisor" value={postProject ? postProject.supervisor : ''} onChange={(e) => setPostProject({...postProject, supervisor: e.target.value})}></input>
               </label>
               <label>
                   Project Description: 
                   <input type="text" name="description" label="Description" value={postProject ? postProject.description : ''} onChange={(e) => setPostProject({...postProject, description: e.target.value})}></input>
               </label>
               <input className="submitButton" type="submit" name="submit" onClick={() => updateProject(id, postProject)}></input>
               <Button onClick={clearFields}>
                    <ClearIcon/>
                    Clear
                </Button>
           </form>
           {!projects.length ? <CircularProgress /> : (
                <Grid >
                    {userProject.map((project) => (
                        <Grid className="paper" key={project._id} item>
                            <p>{project.title}</p>
                            <p>{project.supervisor}</p>
                            <p>{project.description}</p>
                            <Button onClick={() => handleProjectEdit(project)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            <Button onClick={() => dispatch(deleteProject(project._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default CreateEditProject